import type { BaseModel } from './common.types';
import type { TapStatusType, TapType } from './taps.types';

export interface VisitTapModel extends BaseModel {
  // Checks
  preCleanRating?: PreCleanRatingType;
  wastageStatus?: WastageStatusType;
  hasBeerIn?: boolean;
  manualWastage?: number;
  totalWastage?: number;
  dispenseTemperature?: number;
  tapTaintProfile?: TapTaintProfileType;
  // Props
  isUnserviced?: boolean;
  // Relations
  visitBarId: string;
  visitFobId?: string;
  visitRemoteCoolerId?: string;
  visitPythonId?: string;
  // Tap Fields
  tapId: string;
  tapName: string;
  tapPosition: number;
  tapStatus: TapStatusType;
  tapType: TapType;
  tapTBarNumber?: number;
  tapLineLength?: number;
  // Tap Relations
  tapBarId: string;
  tapFobId?: string;
  tapProductId?: string;
  tapRemoteCoolerId?: string;
  tapPythonId?: string;
  // Product Fields
  productName?: string;
  productDispenseSpeedMin?: number;
  productDispenseSpeedMax?: number;
  productDispenseTempMin?: number;
  productDispenseTempMax?: number;
}

export type VisitTapParams = Omit<
  VisitTapModel,
  | 'tapName'
  | 'productName'
  | 'productDispenseSpeedMin'
  | 'productDispenseSpeedMax'
  | 'productDispenseTempMin'
  | 'productDispenseTempMax'
  | 'medias'
  | 'createdAt'
  | 'updatedAt'
>;

export interface VisitActiveBarTapModel {
  id: string;
  name: string;
  position: number;
  tBarNumber: number | null;
  bar: string;
  product: string;
  remoteCooler: string | null;
  fob: string | null;
  python: string | null;
  lineLength: number | null;
  status: string;
  migrationId: string | null;
  type: TapType;
}

// export interface VisitTapParams {
//   id?: string;
//   visitId: string;
//   barId: string;
//   tapId: string;
//   preCleanRating?: string | null;
//   wastageStatus?: WastageStatusType | null;
//   hasBeerIn?: boolean;
//   isServiced?: boolean;
//   manualWastage?: number | null;
//   totalWastage?: number | null;
//   sealTypeBefore?: TapSealType | null;
//   sealTypeAfter?: TapSealType | null;
//   dispenseTemperature?: number | null;
//   dispenseSpeedBefore?: number | null;
//   dispenseSpeedAfter?: number | null;
//   tapSealHygiene?: boolean | null;
//   flushWaterClear?: boolean | null;
//   tapTaintProfile?: TapTaintProfileType | null;
// }
export interface ListVisitsTapResponse {
  result: VisitTapModel[];
  limit: number;
  offset: number;
  count: number;
}

export type PreCleanRatingType = 'A' | 'B' | 'C' | 'D';

export enum WastageStatusType {
  FULL = 'Full',
  EMPTY = 'Empty',
  PARTIAL = 'Partial'
}

export enum CleanRatingType {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  None = 'None'
}

export enum TapTaintProfileType {
  PASS = 'Pass',
  CHLOROPHENOL = 'Chlorophenol',
  TRICHLOROANISOLE = 'Trichloroanisole',
  INFECTION_OFF_BEER = 'Infection / Off beer',
  OXIDATION = 'Oxidation',
  NONE = 'None'
}
